// import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Allcertificates from "../../../../Image/All_certificates.png";
import image_active from "../../../../Image/image_active.png";
import image_cencel from "../../../../Image/image_cencel.png";
import { Flex } from "@aws-amplify/ui-react";
import image_Signature from "../../../../Image/image_Signature.png";
import Button from "@mui/material/Button";
import Dialog from "./Dialog";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { APIEndpoint, BasicAuthUser } from "../../../../client/apiconfig"; // นำเข้า BASE_URL จาก apiConfig

export default function FixedContainer() {
  const [signature, setSignature] = useState<string | null>(null);

  useEffect(() => {
    const fetchSignature = async () => {
      const storedDataPerson = localStorage.getItem("Data");

      if (!storedDataPerson) {
        console.error("No data found in localStorage");
        return;
      }

      const parsedDataPerson = JSON.parse(storedDataPerson);
      const accountId = parsedDataPerson?.result?.data?.account_id;

      try {
        const response = await axios.get(
          `${APIEndpoint.DigitalSignatureImage}?account_id=${accountId}`,
          {
            auth: BasicAuthUser
          }
        );
        setSignature(response.data.result.image_base64);
        localStorage.setItem("digital_signature_image_code", JSON.stringify(response.data.result.digital_signature_image_code
        ));
      } catch (error) {
        console.error("Error fetching signature:", error);
      }
    };

    fetchSignature();
  }, []);

  return (
    <Grid container spacing={2}>
      {/* หน่วยบริการ */}
      <Grid item xs={12} lg={12}>
        <Box
          sx={{
            mt: 10,
            background: "#ffffff",
            borderRadius: "15px",
            p: 2,
          }}
        >
          <Grid item xs={12} lg={12}>
            <Box
              sx={{
                fontSize: "23px",
                color: "#2F4491",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mt: 4,
              }}
            >
              สร้างลายเซ็นของคุณ
            </Box>
          </Grid>
          <Grid>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column", // Stack items vertically
                justifyContent: "center",
                alignItems: "center",
                mt: 4,
                backgroundColor: "#FFFFFF", // พื้นหลังสีขาว
                border: "1px dashed #A1C0FF", // ขอบเส้นปะสีดำ
                borderRadius: "15px", // ขอบมน
                width: "600px", // กำหนดความกว้าง
                height: "auto", // Let height adjust automatically
                mx: "auto", // ทำให้กรอบอยู่ตรงกลางแนวนอน
                p: 2, // Optional padding for inner content
              }}
            >
              <Box
                sx={{
                  mt: 12,
                  display: "flex",
                  justifyContent: "center", // จัดให้อยู่ตรงกลางแนวนอน
                  alignItems: "center", // จัดให้อยู่ตรงกลางแนวตั้ง (ในกรณีที่ต้องการ)
                }}
              >
                {signature ? (
                  <img
                    src={`data:image/png;base64,${signature}`}
                    loading="lazy"
                    width={300}
                    alt="Signature"
                  />
                ) : (
                  <img
                    src={image_Signature}
                    loading="lazy"
                    width={300}
                    alt="Signature placeholder"
                  />
                )}
              </Box>
              <Box
                sx={{
                  mt: 4,
                  display: "flex",
                  justifyContent: "center", // จัดให้อยู่ตรงกลางแนวนอน
                  alignItems: "center", // จัดให้อยู่ตรงกลางแนวตั้ง (ในกรณีที่ต้องการ)
                }}
              >
                {/* Dialog */}
                <Dialog />
                {/*  */}
              </Box>
              <Box sx={{ mt: 6 }}></Box>
            </Box>
          </Grid>
          <Box sx={{ mt: 6 }}></Box>
        </Box>
      </Grid>
    </Grid>
  );
}
